export const RolesKeys = {
  allRoles: ['roles'] as const,
  permissionsByRoleId: (role_id: number) => ['permission_detail', role_id],
} as const
